import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=9bde4c66&scoped=true"
import script from "./Waiting.vue?vue&type=script&lang=js"
export * from "./Waiting.vue?vue&type=script&lang=js"
import style0 from "./Waiting.vue?vue&type=style&index=0&id=9bde4c66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bde4c66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bde4c66')) {
      api.createRecord('9bde4c66', component.options)
    } else {
      api.reload('9bde4c66', component.options)
    }
    module.hot.accept("./Waiting.vue?vue&type=template&id=9bde4c66&scoped=true", function () {
      api.rerender('9bde4c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Waiting.vue"
export default component.exports